/**
 * =========================================================================================
 *     DOBLER DATA SOLUTIONS, LLC - PROPRIETARY AND CONFIDENTIAL
 * =========================================================================================
 * The source code contained herein is owned by Dobler Data Solutions, LLC. The source code
 * and all other copyrightable materials related thereto, including without limitation, all
 * text, logos, designs, graphics, other files, and other code, is protected under Title 17
 * of the United States Code. Any use, including any commercial use, distribution,
 * republication, or display of the source code or any other copyrightable materials related
 * thereto is strictly prohibited. Copyright © 2026 Dobler Data Solutions, LLC.
 * ALL RIGHTS RESERVED.
 * =========================================================================================
 *
 *     File Name       :   useAuth.ts
 *     Description     :   Hook returning authenticated caller identity and sign-out from AuthContext.
 *     Module          :   005-web-shell
 *     Component Type  :   Hook
 *
 * -----------------------------------------------------------------------------------------
 *     CHANGE HISTORY
 * -----------------------------------------------------------------------------------------
 *     Version     Date            Author              Description
 * -----------------------------------------------------------------------------------------
 *     1.0         2026-06-23      Peter Dobler        Initial creation
 * -----------------------------------------------------------------------------------------
 *
 *     DEPENDENCIES
 * -----------------------------------------------------------------------------------------
 *     External        :   react
 *     Internal        :   AuthProvider
 *
 *     EXPORTS
 * -----------------------------------------------------------------------------------------
 *     useAuth
 *
 * =========================================================================================
 */

import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "./AuthProvider.js";

/**
 * Returns the current authentication state and sign-out action from the nearest AuthContext.
 * Must be used inside an <AuthProvider> tree.
 */
export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
